import React from 'react';
import styled, { css } from 'styled-components';

interface ProgressBarProps {
  progress: number;
  sx?: Record<string, unknown>;
}

const LineContainer = styled.div`
  width: 214px;
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
`;

const FilledLine = styled.div<{ progress: number }>`
  height: 100%;
  background-color: #2055ff;
  border-radius: 4px;
  opacity: 0;
  width: ${({ progress }) => progress}%;
  transition: width 0.5s ease;
  ${({ progress }) =>
    progress &&
    css`
      opacity: 1;
    `}
`;

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress, sx = {} }) => {
  return (
    <LineContainer style={sx}>
      <FilledLine progress={progress} />
    </LineContainer>
  );
};
